import $api from "../http";

class SavePlacesServiceClass {
  savePlace(gymListingId: string) {
    return $api.post(`api/saved-place`, {
      gymListingId,
    });
  }

  deletePlace(id: string) {
    return $api.delete(`api/saved-place/${id}`);
  }

  getAll() {
    return $api.get(`api/saved-place/get-all`);
  }
}

export const SavePlacesService = new SavePlacesServiceClass();
